import React from "react";
export default function UrlIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1818 6H14.3636C14.8412 6 15.314 6.09406 15.7552 6.2768C16.1964 6.45955 16.5973 6.7274 16.9349 7.06507C17.2726 7.40273 17.5405 7.8036 17.7232 8.24479C17.9059 8.68597 18 9.15883 18 9.63636C18 10.1139 17.9059 10.5868 17.7232 11.0279C17.5405 11.4691 17.2726 11.87 16.9349 12.2077C16.5973 12.5453 16.1964 12.8132 15.7552 12.9959C15.314 13.1787 14.8412 13.2727 14.3636 13.2727H12.1818M7.81818 13.2727H5.63636C5.15883 13.2727 4.68597 13.1787 4.24479 12.9959C3.8036 12.8132 3.40273 12.5453 3.06507 12.2077C2.38312 11.5257 2 10.6008 2 9.63636C2 8.67194 2.38312 7.74702 3.06507 7.06507C3.74702 6.38312 4.67194 6 5.63636 6H7.81818"
          stroke="#12344D"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.0918 9.63672H12.91"
          stroke="#12344D"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
